import React from 'react';
import {observer} from 'mobx-react';
import {withState} from 'shared/core';
import {types, endpoints} from 'main/tools';
import {Panel, SearchBox, Pagination, InteractiveContext, FancyFilter, FancyFilterPills} from 'components';
import PayrollUpdateDigest from './PayrollUpdateDigest';
import {PayrollUpdatesListState} from '../state';
import {PayrollUpdate} from 'stores/payroll';
import {FormattedMessage} from 'react-intl';
import _ from 'lodash';

const FilterRow = observer(({...rest}) => {
  return (
    <Panel compact className='mb2'>
      <div className='FilterRow flex align-items-middle bg-white'>
        <div className='flex flex-wrap flex-grow row-gap-2'>
          <SearchBox {...rest}/>
          <div className='ml1 flex align-items-start'>
            <FancyFilterPills {...rest}/>
          </div>
        </div>
        <div className='FilterGroup-searchable flex align-items-center flex-wrap ml2'>
          <FancyFilter filters={['payroll_update_status', 'location', 'department', 'employment_status', 'employment_type']} {...rest}/>
        </div>
      </div>
    </Panel>
  );
});

const EmptyState = () => {
  return (
    <Panel>
      <div className='center jumbo rounded h5 py2 px1 Table-emptyState'>
        <FormattedMessage id={'payroll_updates.No payroll updates to show.'}/>
      </div>
    </Panel>
  );
};

const PayrollUpdatePanel = observer(({models, isUpdating, uiState}) => {
  if (_.isEmpty(uiState.payrollUpdatesGroupedByDate(models))) return <EmptyState/>;

  return uiState.payrollUpdatesGroupedByDate(models).map(payrollUpdate =>
    <PayrollUpdateDigest key={payrollUpdate.date} isUpdating={isUpdating} uiState={uiState} payrollUpdate={payrollUpdate}/>
  );
});

const PayrollUpdatesList = observer(({uiState}) => {
  return (
    <div className='relative'>
      <InteractiveContext
        proxy={{
          type: 'async',
          modelType: types.PAYROLL_UPDATE,
          model: PayrollUpdate,
          endpoint: endpoints.PAYROLL_UPDATES,
          pageSize: 50
        }}
        saveStateToUrl
        initialFilter={{payroll_update_status: 'submitted'}}
        onMount={agent => uiState.setInteractiveAgent(agent)}
        uiState={uiState}
      >
        <FilterRow/>
        <PayrollUpdatePanel uiState={uiState}/>
        <Pagination />
      </InteractiveContext>
    </div>
  );
});

export default withState(PayrollUpdatesList, PayrollUpdatesListState);
